/* eslint semi: 1 */
import { defineStore } from 'pinia';

export const SCHEDULE_PAGE_SIZE = 12;

interface ScheduleQueryState {
  searchText: string;
  selectedDate: string | null;
  selectedTags: string[];
  max: number;
}

export const useScheduleQueryStore = defineStore('schedule-query-store', {
  state: (): ScheduleQueryState => ({
    searchText: '',
    selectedDate: null,
    selectedTags: [],
    max: SCHEDULE_PAGE_SIZE,
  }),
  getters: {
    hasActiveFilters (state): boolean {
      return !!state.searchText;
    }
  },
  actions: {
    setSearchText (text: string): void {
      this.searchText = text;
    },
    setSelectedDate (date: string | null): void {
      this.selectedDate = date;
    },
    setSelectedTags (tags: string[]): void {
      this.selectedTags = tags;
    }
  }
});

export type ScheduleQueryStore = ReturnType<typeof useScheduleQueryStore>;
